// Supported language codes
export const SUPPORTED_LANGUAGES = ['en-US', 'ja-JP'] as const;

// Default/fallback language (base)
export const DEFAULT_LANGUAGE = 'en-US';

// Language display names for UI (e.g., language selector)
export const LANGUAGE_NAMES: Record<
    (typeof SUPPORTED_LANGUAGES)[number],
    string
> = {
    'en-US': 'English',
    'ja-JP': '日本語',
};

// Type for supported language codes
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
